import requests from '../../api/client'
import { CardRegisterResponse } from '../../types/otp'

interface CardRegisterJson {
  documento: string
  nome_titular: string
  numero_cartao: string
  mes_ano_vencimento: string
  cvv: string
}

export default async function fetchCardRegister(
  cardRegisterJson: CardRegisterJson
): Promise<CardRegisterResponse | null> {
  // Sem try/catch de propósito: o ApiError (inclusive o HTTP 200 com
  // retorno:false) precisa chegar a quem chama, que exibe a mensagem da API.
  const { retorno, mensagem, dados } = (await requests.cardRegister(
    cardRegisterJson
  )) as CardRegisterResponse

  return { retorno, mensagem, dados }
}